const initializeSlider = () => {
  // when slider is initialized, must be called before slick init function
  $('#airticket-map-offers ul').on('init', function(event, slick, currentSlide, nextSlide) {
    $('#airticket-map-offers').addClass('loaded')
  })

  $('#airticket-map-offers ul').slick({
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    draggable: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })
}

export default initializeSlider



// WEBPACK FOOTER //
// ./app/offers/initializeSlider.js